module.exports = __webpack_public_path__ + "static/img/training_system_hy_s3.fb979939.png";